export const touristsPlaceholder = 'Количество туристов';
